import React from "react";
import "../ThreatLandscape.css";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

import {
    FaShieldVirus,
    FaEnvelopeOpenText,
    FaCloud,
    FaRobot,
    FaUserSecret,
    FaNetworkWired,
    FaArrowRight,
} from "react-icons/fa";

const threats = [
    {
        icon: <FaShieldVirus />,
        title: "Ransomware Attacks",
        description:
            "Cybercriminals encrypt critical business data and demand ransom payments, causing downtime, financial losses, and operational disruption.",
    },
    {
        icon: <FaEnvelopeOpenText />,
        title: "Phishing & Email Fraud",
        description:
            "Sophisticated phishing campaigns deceive employees into revealing credentials, financial information, and confidential business data.",
    },
    {
        icon: <FaCloud />,
        title: "Cloud Security Risks",
        description:
            "Misconfigured cloud environments and weak identity controls expose organizations to data breaches and unauthorized access.",
    },
    {
        icon: <FaRobot />,
        title: "AI-Powered Cyber Attacks",
        description:
            "Attackers now leverage Artificial Intelligence to automate phishing, malware generation, and vulnerability discovery.",
    },
    {
        icon: <FaUserSecret />,
        title: "Insider Threats",
        description:
            "Employees, contractors, or compromised accounts can intentionally or accidentally expose sensitive corporate information.",
    },
    {
        icon: <FaNetworkWired />,
        title: "Supply Chain Attacks",
        description:
            "Cyber attackers target trusted software vendors and service providers to compromise multiple organizations through a single breach.",
    },
];

const ThreatLandscape = () => {
    return (
        <section className="threat-section">

            <div className="container">

                {/* Heading */}

                <motion.div
                    className="section-heading"
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8 }}
                >

                    <span className="section-tag">
                        Cyber Threat Intelligence
                    </span>

                    <h2>

                        Today's
                        <span> Cybersecurity Threat Landscape</span>

                    </h2>

                    <p>

                        Cyber threats continue to evolve at an
                        unprecedented pace. Organizations of every
                        size are facing increasingly sophisticated
                        attacks targeting their infrastructure,
                        applications, cloud environments, and
                        sensitive business information. Understanding
                        these risks is the first step toward building
                        a resilient cybersecurity strategy.

                    </p>

                </motion.div>

                {/* Threat Cards */}

                <div className="threat-grid">

                    {threats.slice(0, 3).map((item, index) => (

                        <motion.div
                            key={index}
                            className="threat-card"
                            initial={{ opacity: 0, y: 50 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{
                                duration: .5,
                                delay: index * .15
                            }}
                        >

                            <div className="threat-icon">

                                {item.icon}

                            </div>

                            <h3>

                                {item.title}

                            </h3>

                            <p>

                                {item.description}

                            </p>

                        </motion.div>

                    ))}

                    {threats.slice(3).map((item, index) => (

                        <motion.div
                            key={index + 3}
                            className="threat-card"
                            initial={{ opacity: 0, y: 50 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{
                                duration: 0.5,
                                delay: index * 0.15,
                            }}
                        >

                            <div className="threat-icon">

                                {item.icon}

                            </div>

                            <h3>

                                {item.title}

                            </h3>

                            <p>

                                {item.description}

                            </p>

                        </motion.div>

                    ))}

                </div>

                {/* ===============================
            SECURITY INSIGHTS
        =============================== */}

                <motion.div
                    className="threat-stats"
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8 }}
                >

                    <div className="stat-card">

                        <h2>24×7</h2>

                        <span>Continuous Threat Monitoring</span>

                    </div>

                    <div className="stat-card">

                        <h2>AI</h2>

                        <span>Driven Threat Intelligence</span>

                    </div>

                    <div className="stat-card">

                        <h2>Zero</h2>

                        <span>Trust Security Architecture</span>

                    </div>

                    <div className="stat-card">

                        <h2>100%</h2>

                        <span>Commitment to Data Protection</span>

                    </div>

                </motion.div>

                {/* ===============================
            CTA
        =============================== */}

                <motion.div
                    className="threat-cta"
                    initial={{ opacity: 0, scale: 0.95 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8 }}
                >

                    <h2>

                        Don't Wait Until an Attack Happens

                    </h2>

                    <p>

                        Every organization is a potential target.
                        Strengthen your cybersecurity posture today
                        with proactive protection, continuous monitoring,
                        and expert guidance from
                        <strong> BlueLotus Infrasafety Projects Private Limited.</strong>

                    </p>

                    <a
                        href="/consultation"
                        className="primary-btn"
                    >

                        Protect Your Business Today

                        <FaArrowRight />

                    </a>

                </motion.div>

            </div>

        </section>

    );
};

export default ThreatLandscape;